<template lang="pug">
.expansion-panel
  .panel-header(@click="toggle")
    .panel-title {{ title }}
    img(
      src="@/assets/icons/chevron-right.svg"
      :class="{ 'rotated': isExpanded }"
      alt="Toggle"
    ).chevron-icon
  transition(name="expand")
    .panel-content(v-if="isExpanded" v-html="description")
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'ExpansionPanel',
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    initiallyExpanded: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const isExpanded = ref(props.initiallyExpanded);

    const toggle = () => {
      isExpanded.value = !isExpanded.value;
    };

    return {
      isExpanded,
      toggle,
    };
  },
});
</script>

<style lang="scss" scoped>
.expansion-panel {
  margin-bottom: 0;
  border-bottom: 1px solid #e0e0e0;

  &:last-child {
    border-bottom: none;
  }
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  cursor: pointer;
  user-select: none;

  &:hover {
    opacity: 0.8;
  }
}

.panel-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.chevron-icon {
  width: 20px;
  height: 20px;
  opacity: 0.6;
  transition: transform 0.3s ease;
  transform: rotate(90deg);

  &.rotated {
    transform: rotate(270deg);
  }
}

.panel-content {
  padding-bottom: 24px;
  color: #666;
  font-size: 14px;
  line-height: 1.6;

  :deep(p) {
    margin: 0 0 12px 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

  :deep(strong) {
    font-weight: 600;
    color: #333;
  }
}

// Transition animations
.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}

.expand-enter-from,
.expand-leave-to {
  opacity: 0;
  max-height: 0;
}

.expand-enter-to,
.expand-leave-from {
  opacity: 1;
  max-height: 500px;
}
</style>
